import { render, staticRenderFns } from "./bankinfo.vue?vue&type=template&id=c1a4e1f0&scoped=true&"
import script from "./bankinfo.vue?vue&type=script&lang=js&"
export * from "./bankinfo.vue?vue&type=script&lang=js&"
import style0 from "./bankinfo.vue?vue&type=style&index=0&id=c1a4e1f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a4e1f0",
  null
  
)

export default component.exports